import script from "./QueueList.vue?vue&type=script&setup=true&lang=ts"
export * from "./QueueList.vue?vue&type=script&setup=true&lang=ts"

import "./QueueList.vue?vue&type=style&index=0&id=44e5195c&lang=css"

const __exports__ = script;

export default __exports__